import React, { useState, useMemo, useRef } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
  MarkerClusterer,
} from "@react-google-maps/api";

// 🚀 FontAwesome React Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faExpand,
  faCompress,
} from "@fortawesome/free-solid-svg-icons";

import { arrayBOBLocations } from "./../BobMap/bobBranchesData";

const containerStyle = { width: "100%", height: "100%" };
const center = { lat: 33.8547, lng: 35.8623 };

const MapView = ({ onBack }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, 
  });

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const mapRef = useRef(null);

  const branches = useMemo(() => {
    return arrayBOBLocations.map((loc) => ({
      id: loc[0],
      name: loc[1].trim(),
      lat: parseFloat(loc[2]),
      lng: parseFloat(loc[3]),
      address: "Authorized BOB Outlet",
    }));
  }, []);

  const onLoad = (map) => {
    mapRef.current = map;
    const bounds = new window.google.maps.LatLngBounds();
    branches.forEach((b) => {
      if (b.lat && b.lng) bounds.extend({ lat: b.lat, lng: b.lng });
    });
    map.fitBounds(bounds, { top: 70, bottom: 70, left: 70, right: 70 });
  };

  if (!isLoaded) return <div className="p-5 text-center text-primary fw-bold">Loading Map...</div>;

  const wrapperClasses = isFullscreen
    ? "position-fixed top-0 start-0 w-100 h-100 bg-white"
    : "position-relative w-100 h-100 rounded-3 overflow-hidden shadow border";

  const btnStyle = {
    zIndex: 10,
    borderRadius: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    transition: "all 0.2s ease",
    border: "1px solid #dee2e6",
  };

  return (
    <div 
      className={wrapperClasses} 
      style={{ zIndex: isFullscreen ? 1050 : 1, transition: "0.3s ease" }}
    >
      
      {/* 🚀 BACK BUTTON */}
      <button 
        onClick={onBack} 
        className="btn btn-light position-absolute d-flex align-items-center gap-2 shadow-sm p-2 px-3"
        style={{ ...btnStyle, top: "15px", left: "15px" }}
      >
        <FontAwesomeIcon icon={faArrowLeft} className="text-primary" />
        <span className="fw-bold" style={{ fontSize: "14px" }}>Back</span>
      </button>

      {/* 🚀 MAXIMIZE TOGGLE */}
      <button 
        onClick={() => setIsFullscreen(!isFullscreen)} 
        className="btn btn-light position-absolute d-flex align-items-center justify-content-center shadow-sm"
        style={{ ...btnStyle, top: "15px", right: "15px", width: "42px", height: "42px" }}
      >
        <FontAwesomeIcon 
          icon={isFullscreen ? faCompress : faExpand} 
          className="fs-5 text-dark" 
        />
      </button>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={9}
        onLoad={onLoad}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
        }}
      >
        <MarkerClusterer
          options={{
            gridSize: 30,
            maxZoom: 10,
            minimumClusterSize: 20
          }}
        >
          {(clusterer) =>
            branches.map((branch) => (
              <Marker
                key={branch.id}
                position={{ lat: branch.lat, lng: branch.lng }}
                clusterer={clusterer}
                onClick={() => setSelectedBranch(branch)}
              />
            ))
          }
        </MarkerClusterer>

        {selectedBranch && (
          <InfoWindow
            position={{ lat: selectedBranch.lat, lng: selectedBranch.lng }}
            onCloseClick={() => setSelectedBranch(null)}
          >
            <div className="p-2">
              <h6 className="fw-bold text-primary mb-1">{selectedBranch.name}</h6>
              <p className="small text-muted mb-0">{selectedBranch.address}</p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
};

export default MapView;